import { UserManager } from 'oidc-client';
import { AUTH_CONFIG } from './authConfig';

const userManager = new UserManager(AUTH_CONFIG);
export default userManager;
